import { useSelector } from "react-redux";

import { toastData } from "@src/@slice/toastSlice";

import ToastUi from "./ToastUi";
import SnackbarUi from "./SnackbarUi";

export default function ToastContainer() {
  const { toasts, snackbars } = useSelector(toastData);

  return (
    <div className="app-toast-container">
      {toasts.map((toast) => (
        <ToastUi
          key={toast.id}
          id={toast.id}
          message={toast.message}
          bottomPosition={toast.bottomPosition}
          position={toast.position}
          textAlign={toast.textAlign}
          removeTime={toast.removeTime}
          isAutoRemove={toast.isAutoRemove}
          icon={toast.icon}
          emoji={toast.emoji}
          onClick={toast.onClick}
        />
      ))}
      {snackbars.map((snackbar) => (
        <SnackbarUi
          key={snackbar.id}
          id={snackbar.id}
          message={snackbar.message}
          type={snackbar.type}
          isShowClose={snackbar.isShowClose}
          bottomPosition={snackbar.bottomPosition}
          position={snackbar.position}
          textAlign={snackbar.textAlign}
          removeTime={snackbar.removeTime}
          isAutoRemove={snackbar.isAutoRemove}
          icon={snackbar.icon}
          buttonText={snackbar.buttonText}
          onClick={snackbar.onClick}
        />
      ))}
    </div>
  );
}
